// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as ArenaRouteImport } from './routes/arena'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as EventsRouteImport } from './routes/events'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as UsernameInviteRouteImport } from './routes/$username.invite'
import { Route as AuthenticatedActivityRouteImport } from './routes/_authenticated/activity'
import { Route as AuthenticatedCirclesRouteImport } from './routes/_authenticated/circles'
import { Route as AuthenticatedCoffeeRouteImport } from './routes/_authenticated/coffee'
import { Route as AuthenticatedExpertRequestsRouteImport } from './routes/_authenticated/expert-requests'
import { Route as AuthenticatedHomeRouteImport } from './routes/_authenticated/home'
import { Route as AuthenticatedMarketplaceRouteImport } from './routes/_authenticated/marketplace'
import { Route as AuthenticatedNotificationsRouteImport } from './routes/_authenticated/notifications'
import { Route as AuthenticatedPeopleRouteImport } from './routes/_authenticated/people'
import { Route as AuthenticatedProfileRouteImport } from './routes/_authenticated/profile'
import { Route as AuthenticatedRequestsRouteImport } from './routes/_authenticated/requests'
import { Route as AuthenticatedWorkRouteImport } from './routes/_authenticated/work'
import { Route as AfishaCityRouteImport } from './routes/afisha.$city'
import { Route as AuthCallbackRouteImport } from './routes/auth_.callback'
import { Route as EEventIdRouteImport } from './routes/e.$eventId'
import { Route as LegalAcikRizaRouteImport } from './routes/legal/acik-riza'
import { Route as LegalAydinlatmaMetniRouteImport } from './routes/legal/aydinlatma-metni'
import { Route as LegalCerezPolitikasiRouteImport } from './routes/legal/cerez-politikasi'
import { Route as LegalKullanimKosullariRouteImport } from './routes/legal/kullanim-kosullari'
import { Route as ReqRequestIdRouteImport } from './routes/req.$requestId'
import { Route as WPostIdRouteImport } from './routes/w.$postId'
import { Route as AuthenticatedAdminArenaRouteImport } from './routes/_authenticated/admin.arena'
import { Route as AuthenticatedAdminBannersRouteImport } from './routes/_authenticated/admin.banners'
import { Route as AuthenticatedAdminCoffeeGroupsRouteImport } from './routes/_authenticated/admin.coffee-groups'
import { Route as AuthenticatedAdminDeletionsRouteImport } from './routes/_authenticated/admin.deletions'
import { Route as AuthenticatedAdminInstallRouteImport } from './routes/_authenticated/admin.install'
import { Route as AuthenticatedAdminPushRouteImport } from './routes/_authenticated/admin.push'
import { Route as AuthenticatedAdminResidentsRouteImport } from './routes/_authenticated/admin.residents'
import { Route as AuthenticatedAdminRolesRouteImport } from './routes/_authenticated/admin.roles'
import { Route as AuthenticatedArenaPeopleRouteImport } from './routes/_authenticated/arena.people'
import { Route as AuthenticatedCirclesIndexRouteImport } from './routes/_authenticated/circles.index'
import { Route as AuthenticatedCirclesCircleIdRouteImport } from './routes/_authenticated/circles.$circleId'
import { Route as AuthenticatedEventsNewRouteImport } from './routes/_authenticated/events_.new'
import { Route as AuthenticatedExpertRequestsRequestIdRouteImport } from './routes/_authenticated/expert-requests_.$requestId'
import { Route as AuthenticatedMarketplaceListingIdRouteImport } from './routes/_authenticated/marketplace.$listingId'
import { Route as AuthenticatedMarketplaceNewRouteImport } from './routes/_authenticated/marketplace.new'
import { Route as AuthenticatedPeopleUserIdRouteImport } from './routes/_authenticated/people_.$userId'
import { Route as AuthenticatedProfileSetupRouteImport } from './routes/_authenticated/profile_.setup'
import { Route as AuthenticatedCoffeeGroupGroupIdRouteImport } from './routes/_authenticated/coffee_.group.$groupId'
import { Route as AuthenticatedEventsEventIdEditRouteImport } from './routes/_authenticated/events_.$eventId.edit'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const ArenaRoute = ArenaRouteImport.update({
            id: '/arena',path: '/arena',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const EventsRoute = EventsRouteImport.update({
            id: '/events',path: '/events',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const UsernameInviteRoute = UsernameInviteRouteImport.update({
            id: '/$username/invite',path: '/$username/invite',getParentRoute: () => rootRouteImport
          })
const AuthenticatedActivityRoute = AuthenticatedActivityRouteImport.update({
            id: '/activity',path: '/activity',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedCirclesRoute = AuthenticatedCirclesRouteImport.update({
            id: '/circles',path: '/circles',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedCoffeeRoute = AuthenticatedCoffeeRouteImport.update({
            id: '/coffee',path: '/coffee',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedExpertRequestsRoute = AuthenticatedExpertRequestsRouteImport.update({
            id: '/expert-requests',path: '/expert-requests',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedHomeRoute = AuthenticatedHomeRouteImport.update({
            id: '/home',path: '/home',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedMarketplaceRoute = AuthenticatedMarketplaceRouteImport.update({
            id: '/marketplace',path: '/marketplace',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedNotificationsRoute = AuthenticatedNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPeopleRoute = AuthenticatedPeopleRouteImport.update({
            id: '/people',path: '/people',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedRequestsRoute = AuthenticatedRequestsRouteImport.update({
            id: '/requests',path: '/requests',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedWorkRoute = AuthenticatedWorkRouteImport.update({
            id: '/work',path: '/work',getParentRoute: () => AuthenticatedRouteRoute
          })
const AfishaCityRoute = AfishaCityRouteImport.update({
            id: '/afisha/$city',path: '/afisha/$city',getParentRoute: () => rootRouteImport
          })
const AuthCallbackRoute = AuthCallbackRouteImport.update({
            id: '/auth_/callback',path: '/auth/callback',getParentRoute: () => rootRouteImport
          })
const EEventIdRoute = EEventIdRouteImport.update({
            id: '/e/$eventId',path: '/e/$eventId',getParentRoute: () => rootRouteImport
          })
const LegalAcikRizaRoute = LegalAcikRizaRouteImport.update({
            id: '/legal/acik-riza',path: '/legal/acik-riza',getParentRoute: () => rootRouteImport
          })
const LegalAydinlatmaMetniRoute = LegalAydinlatmaMetniRouteImport.update({
            id: '/legal/aydinlatma-metni',path: '/legal/aydinlatma-metni',getParentRoute: () => rootRouteImport
          })
const LegalCerezPolitikasiRoute = LegalCerezPolitikasiRouteImport.update({
            id: '/legal/cerez-politikasi',path: '/legal/cerez-politikasi',getParentRoute: () => rootRouteImport
          })
const LegalKullanimKosullariRoute = LegalKullanimKosullariRouteImport.update({
            id: '/legal/kullanim-kosullari',path: '/legal/kullanim-kosullari',getParentRoute: () => rootRouteImport
          })
const ReqRequestIdRoute = ReqRequestIdRouteImport.update({
            id: '/req/$requestId',path: '/req/$requestId',getParentRoute: () => rootRouteImport
          })
const WPostIdRoute = WPostIdRouteImport.update({
            id: '/w/$postId',path: '/w/$postId',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminArenaRoute = AuthenticatedAdminArenaRouteImport.update({
            id: '/admin/arena',path: '/admin/arena',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminBannersRoute = AuthenticatedAdminBannersRouteImport.update({
            id: '/admin/banners',path: '/admin/banners',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminCoffeeGroupsRoute = AuthenticatedAdminCoffeeGroupsRouteImport.update({
            id: '/admin/coffee-groups',path: '/admin/coffee-groups',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminDeletionsRoute = AuthenticatedAdminDeletionsRouteImport.update({
            id: '/admin/deletions',path: '/admin/deletions',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminInstallRoute = AuthenticatedAdminInstallRouteImport.update({
            id: '/admin/install',path: '/admin/install',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminPushRoute = AuthenticatedAdminPushRouteImport.update({
            id: '/admin/push',path: '/admin/push',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminResidentsRoute = AuthenticatedAdminResidentsRouteImport.update({
            id: '/admin/residents',path: '/admin/residents',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminRolesRoute = AuthenticatedAdminRolesRouteImport.update({
            id: '/admin/roles',path: '/admin/roles',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedArenaPeopleRoute = AuthenticatedArenaPeopleRouteImport.update({
            id: '/arena/people',path: '/arena/people',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedCirclesIndexRoute = AuthenticatedCirclesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedCirclesRoute
          })
const AuthenticatedCirclesCircleIdRoute = AuthenticatedCirclesCircleIdRouteImport.update({
            id: '/$circleId',path: '/$circleId',getParentRoute: () => AuthenticatedCirclesRoute
          })
const AuthenticatedEventsNewRoute = AuthenticatedEventsNewRouteImport.update({
            id: '/events_/new',path: '/events/new',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedExpertRequestsRequestIdRoute = AuthenticatedExpertRequestsRequestIdRouteImport.update({
            id: '/expert-requests_/$requestId',path: '/expert-requests/$requestId',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedMarketplaceListingIdRoute = AuthenticatedMarketplaceListingIdRouteImport.update({
            id: '/$listingId',path: '/$listingId',getParentRoute: () => AuthenticatedMarketplaceRoute
          })
const AuthenticatedMarketplaceNewRoute = AuthenticatedMarketplaceNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AuthenticatedMarketplaceRoute
          })
const AuthenticatedPeopleUserIdRoute = AuthenticatedPeopleUserIdRouteImport.update({
            id: '/people_/$userId',path: '/people/$userId',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedProfileSetupRoute = AuthenticatedProfileSetupRouteImport.update({
            id: '/profile_/setup',path: '/profile/setup',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedCoffeeGroupGroupIdRoute = AuthenticatedCoffeeGroupGroupIdRouteImport.update({
            id: '/coffee_/group/$groupId',path: '/coffee/group/$groupId',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedEventsEventIdEditRoute = AuthenticatedEventsEventIdEditRouteImport.update({
            id: '/events_/$eventId/edit',path: '/events/$eventId/edit',getParentRoute: () => AuthenticatedRouteRoute
          })





const AuthenticatedCirclesRouteChildren = {
  AuthenticatedCirclesCircleIdRoute: AuthenticatedCirclesCircleIdRoute,AuthenticatedCirclesIndexRoute: AuthenticatedCirclesIndexRoute
}

const AuthenticatedCirclesRouteWithChildren = AuthenticatedCirclesRoute._addFileChildren(AuthenticatedCirclesRouteChildren)




const AuthenticatedMarketplaceRouteChildren = {
  AuthenticatedMarketplaceListingIdRoute: AuthenticatedMarketplaceListingIdRoute,AuthenticatedMarketplaceNewRoute: AuthenticatedMarketplaceNewRoute
}

const AuthenticatedMarketplaceRouteWithChildren = AuthenticatedMarketplaceRoute._addFileChildren(AuthenticatedMarketplaceRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedActivityRoute: AuthenticatedActivityRoute,AuthenticatedCirclesRoute: AuthenticatedCirclesRouteWithChildren,AuthenticatedCoffeeRoute: AuthenticatedCoffeeRoute,AuthenticatedExpertRequestsRoute: AuthenticatedExpertRequestsRoute,AuthenticatedHomeRoute: AuthenticatedHomeRoute,AuthenticatedMarketplaceRoute: AuthenticatedMarketplaceRouteWithChildren,AuthenticatedNotificationsRoute: AuthenticatedNotificationsRoute,AuthenticatedPeopleRoute: AuthenticatedPeopleRoute,AuthenticatedProfileRoute: AuthenticatedProfileRoute,AuthenticatedRequestsRoute: AuthenticatedRequestsRoute,AuthenticatedWorkRoute: AuthenticatedWorkRoute,AuthenticatedAdminArenaRoute: AuthenticatedAdminArenaRoute,AuthenticatedAdminBannersRoute: AuthenticatedAdminBannersRoute,AuthenticatedAdminCoffeeGroupsRoute: AuthenticatedAdminCoffeeGroupsRoute,AuthenticatedAdminDeletionsRoute: AuthenticatedAdminDeletionsRoute,AuthenticatedAdminInstallRoute: AuthenticatedAdminInstallRoute,AuthenticatedAdminPushRoute: AuthenticatedAdminPushRoute,AuthenticatedAdminResidentsRoute: AuthenticatedAdminResidentsRoute,AuthenticatedAdminRolesRoute: AuthenticatedAdminRolesRoute,AuthenticatedArenaPeopleRoute: AuthenticatedArenaPeopleRoute,AuthenticatedEventsNewRoute: AuthenticatedEventsNewRoute,AuthenticatedExpertRequestsRequestIdRoute: AuthenticatedExpertRequestsRequestIdRoute,AuthenticatedPeopleUserIdRoute: AuthenticatedPeopleUserIdRoute,AuthenticatedProfileSetupRoute: AuthenticatedProfileSetupRoute,AuthenticatedCoffeeGroupGroupIdRoute: AuthenticatedCoffeeGroupGroupIdRoute,AuthenticatedEventsEventIdEditRoute: AuthenticatedEventsEventIdEditRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,ArenaRoute: ArenaRoute,AuthRoute: AuthRoute,EventsRoute: EventsRoute,ResetPasswordRoute: ResetPasswordRoute,UsernameInviteRoute: UsernameInviteRoute,AfishaCityRoute: AfishaCityRoute,AuthCallbackRoute: AuthCallbackRoute,EEventIdRoute: EEventIdRoute,LegalAcikRizaRoute: LegalAcikRizaRoute,LegalAydinlatmaMetniRoute: LegalAydinlatmaMetniRoute,LegalCerezPolitikasiRoute: LegalCerezPolitikasiRoute,LegalKullanimKosullariRoute: LegalKullanimKosullariRoute,ReqRequestIdRoute: ReqRequestIdRoute,WPostIdRoute: WPostIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)